// Origine unique de la trace
export const traceOrigin = 'IHM_ANNUAIRE_PSY';

/**
 * Les codes d'évènement à signaler lors d'une trace en log
 *
 * ACCES : Lors de l'accès à l'annuaire
 * RECHERCHE : Lors de la recherche de psychologues
 */
export enum eventCode {
	ACCES = 'ACCES',
	RECHERCHE = 'RECHERCHE'
}

/**
 * Les valeurs possibles de clé pour la trace
 *
 * ORIGIN : Origine de la demande de trace (dans ce module toujours ihm)
 */
export enum logKey {
	ORIGIN = 'origine',
	EVENT_CODE = 'eventCode'
}

/**
 * Les niveaux possibles de trace.
 * ordre de detection : ERROR > WARN > INFO > DEBUG > TRACE
 */
export enum logLevel {
	TRACE = 'TRACE',
	INFO = 'INFO',
	DEBUG = 'DEBUG',
	WARN = 'WARN',
	ERROR = 'ERROR'
}
